var map = {
	"./admin/logo": 12,
	"./admin/logo.png": 12,
	"./avatar": 13,
	"./avatar.png": 13,
	"./history/knopova1": 14,
	"./history/knopova1.jpg": 14,
	"./history/knopova2": 15,
	"./history/knopova2.jpg": 15,
	"./history/knopova3": 16,
	"./history/knopova3.jpg": 16,
	"./history/kojdecky1": 17,
	"./history/kojdecky1.jpg": 17,
	"./history/kojdecky2": 18,
	"./history/kojdecky2.jpg": 18,
	"./history/kojdecky3": 19,
	"./history/kojdecky3.jpg": 19,
	"./history/stodulkova1": 20,
	"./history/stodulkova1.jpg": 20,
	"./history/stodulkova2": 21,
	"./history/stodulkova2.jpg": 21,
	"./history/stodulkova3": 22,
	"./history/stodulkova3.jpg": 22,
	"./history/tacova1": 23,
	"./history/tacova1.jpg": 23,
	"./history/tacova2": 24,
	"./history/tacova2.jpg": 24,
	"./history/tacova3": 25,
	"./history/tacova3.jpg": 25,
	"./history/zemanova1": 26,
	"./history/zemanova1.jpg": 26,
	"./logos/atos": 27,
	"./logos/atos.png": 27,
	"./logos/cgf": 28,
	"./logos/cgf.png": 28,
	"./logos/gympl": 29,
	"./logos/gympl.png": 29,
	"./logos/msmt": 30,
	"./logos/msmt.png": 30,
	"./logos/ostrava": 31,
	"./logos/ostrava.png": 31,
	"./logos/privoz": 32,
	"./logos/privoz.png": 32,
	"./logos/sokol": 33,
	"./logos/sokol.png": 33,
	"./logos/unodor": 34,
	"./logos/unodor.png": 34,
	"./mikulas_25": 35,
	"./mikulas_25.jpg": 35,
	"./nabor": 36,
	"./nabor-24": 37,
	"./nabor-24-gymskolka": 38,
	"./nabor-24-gymskolka.jpg": 38,
	"./nabor-24-rekre": 39,
	"./nabor-24-rekre.jpg": 39,
	"./nabor-24.jpg": 37,
	"./nabor-25": 40,
	"./nabor-25.jpg": 40,
	"./nabor.jpg": 36,
	"./nabor_gymskolka": 41,
	"./nabor_gymskolka.jpg": 41,
	"./pf_2024": 42,
	"./pf_2024.jpg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;